import { FilterToolbarGroup } from 'src/components/Filters';
import { ContentId } from 'src/utils/constants/contentId';
import { ActionOutboxEntityType } from 'src/WebApiController';

import { useTagFiltersBase } from './useTagFiltersBase';

export type TagInfoFilter = {
  tagName: string | null;
  tagValue: string | null;
  tagValues?: string[] | null;
  tagOperation?: string | null;
};

export const useTagFilters = <TFilter extends TagInfoFilter>(
  query: TFilter,
  setQuery: (query: TFilter) => void,
  entityType:
    | ActionOutboxEntityType.Listing
    | ActionOutboxEntityType.Purchase
    | ActionOutboxEntityType.Sale,
  isMultiValue: boolean,
  includeInReport?: boolean,
  disabled?: boolean
): FilterToolbarGroup => {
  const titleContentId =
    entityType === ActionOutboxEntityType.Listing
      ? ContentId.InventoryTag
      : entityType === ActionOutboxEntityType.Sale
        ? ContentId.SaleTag
        : ContentId.PurchaseTag;

  return useTagFiltersBase(
    query.tagName,
    query.tagValue,
    query.tagValues ?? null,
    query.tagOperation ?? null,
    (tagName) =>
      setQuery({
        ...query,
        tagName,
        tagValue: null,
        tagValues: [],
        tagOperation: null,
      }),
    (tagValue) => setQuery({ ...query, tagValue }),
    (tagValues) => setQuery({ ...query, tagValues }),
    (tagOperation) => setQuery({ ...query, tagOperation }),
    titleContentId,
    entityType,
    isMultiValue,
    includeInReport,
    disabled
  );
};
